import React, { useState } from 'react';
import {
  MODIFY_ORDER_TYPE_PROMOTION,
  SECONDARY,
} from '../../../constants';
import { useAppSelector } from '../../../redux/hook';
import Button from '../../Button';
import { changeOrderType } from '../OrderStatus.services';

type OrderStatusEmergencyDeliveryProps = {
  order: any;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isDeliveryEmergency: boolean,
  reductionToClickAndCollect: number
};

export default function OrderStatusEmergencyDelivery({
  reductionToClickAndCollect,
  isDeliveryEmergency,
  order,
  isLoading,
  setIsLoading,
}: OrderStatusEmergencyDeliveryProps) {
  const [loadingChangingOrderType, setLoadingChangingOrderType] = useState(false);
  const { secondaryColor } = useAppSelector((state) => state.configurationReducer);

  if (!isDeliveryEmergency) {
    return null;
  }

  return (
    <div>
      <p className='text-left mb-0 label' style={{ fontSize: 14 }}>
        Vous ne souhaitez pas attendre plus longtemps ? Récupérez votre commande au restaurant dès maintenant et économisez {reductionToClickAndCollect}€
      </p>
      <Button
        type={SECONDARY}
        className="my-2"
        disabled={isLoading}
        isLoading={loadingChangingOrderType}
        style={{
          backgroundColor: secondaryColor,
          borderColor: secondaryColor,
        }}
        onClick={async () => await changeOrderType(setIsLoading, order, MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT, setLoadingChangingOrderType)}
      >
        <span style={{ fontSize: 14 }}>Je me déplace et j'économise {reductionToClickAndCollect}€</span>
      </Button>
    </div>
  );
}
